virtual function string get_type_name();
  return get_name();
endfunction
